import NewYear from "../../../entities/NewYear/ui/NewYear";

const NewYearPage = () => {
    return ( 
    <main>
        <NewYear/>
    </main> 
    );
}
export default NewYearPage;